import Backbone from 'backbone'
import template from './data-source-link.hbs'
import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import appDisplay from 'scoreboard/components/app-display'
import ConfirmPrompt from 'scoreboard/components/confirm-prompt'
import conductor from 'scoreboard/components/conductor'
import sections from 'scoreboard/components/sections'
import guard from 'scoreboard/components/unsaved/guard'
import metadata from 'scoreboard/components/metadata'

const DataSourceLink = Backbone.View.extend({

	events: {
		'click .data-source-link': 'onClickGoToDataSource'
	},

	/**
	 * Provides a link to a data source domain object
	 *
	 * Clicking the link opens a confirm prompt to let the user know that any
	 * changes may be lost when navigating to another section to view the item
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 * @param {Number} options.id - the ID of the domain object
	 * @param {String} options.section - the section for the domain object
	 * @param {String} [options.label] - the label for the link. By default,
	 * something like "Go to Dataset"
	 */
	initialize: function(options = {}) {
		this.options = options || {}
	},

	render: function() {
		this.$el.empty().append(template({
			section: this.options.section,
			id: this.options.id,
			label: this.options.label || this.getGoToLabel()
		}))
		return this
	},

	/**
	 * Returns a label like "Go to Dataset" (the language is changed depending
	 * on the passed-in section)
	 */
	getGoToLabel: function() {
		let metadatum = metadata[this.options.section]
		return i18n.get('common.goto', metadatum.itemCode)
	},

	onClickGoToDataSource: function(e) {
		// prevents opening the source data item selector (since the link may be
		// inside a label tag)
		e & e.preventDefault()

		let section =  i18n.get(metadata[this.options.section].sectionCode)
		// display a confirm prompt
		appDisplay.dialog(new ConfirmPrompt({
			titleKey: 'charts.dataSource.navigate.title',
			message: i18n.get('charts.dataSource.navigate.message', section),
			confirmLabel: this.getGoToLabel(),
			cancelLabel: 'common.cancel',
			onConfirm: () => {
				let url = `${sections.toUrl(this.options.section)}/${this.options.id}`
				// prevent any extra save guards, since they have already confirmed
				// that they are okay with losing any unsaved changes
				guard.stopGuarding()
				conductor.navigate(url, { trigger: true })
			}
		}))
	}

})
export default DataSourceLink
DataSourceLink.__filename__ = 'components/data-source-selector/data-source-link.js'
